<template>
  <a
    class="gift-calc-card"
    href="https://get4click.ru/ext/1OAOZMFO"
    target="_blank"
    rel="noopener"
  >
    <template v-if="isMobile">
      <div class="gift-calc-card__mobile">
        <h4 class="gift-calc-card__heading">
          Вам доступен подарок!
        </h4>
        <div class="gift-calc-card__btn">
          Выбрать подарок
        </div>
      </div>
      <div class="gift-calc-card__gifts">
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-2.png"
          alt="Подарок"
          loading="lazy"
          width="45.45"
          height="45.61"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-4.png"
          alt="Подарок"
          loading="lazy"
          width="45.45"
          height="45.61"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-6.png"
          alt="Подарок"
          loading="lazy"
          width="45.45"
          height="45.61"
        />
      </div>
    </template>
    <template v-else>
      <h4 class="gift-calc-card__heading">
        Поздравляем!
        <br>
        Вам доступен подарок!
      </h4>
      <div class="gift-calc-card__gifts">
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-1.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-2.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-3.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-4.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-5.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
        <img
          src="https://storage.yandexcloud.net/boxberrysite-public/b_images/gitf-6.png"
          alt="Подарок"
          loading="lazy"
          width="63.79"
          height="61.6"
        />
      </div>
      <div class="gift-calc-card__btn">
        Выбрать подарок
      </div>
    </template>
  </a>
</template>

<script>
import deviceInfo from '../../helpers/device';

export default {
  name: 'GiftCalcCard',
  computed: {
    ...deviceInfo,
  },

};
</script>

<style lang="scss" scoped>
.gift-calc-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 18px 30px 30px 29px;
  background-color: #F6F6F6;
  border-radius: 10px;
  @media(max-width: 767px) {
    flex-direction: row;
    align-items: center;
    padding: 14px 20px 15px 20px;
  }
}
.gift-calc-card__heading {
  margin-bottom: 14px;
  font-weight: 700;
  font-size: 27px;
  leading-trim: Cap height;
  line-height: 32px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #ED1651;
  @media(max-width: 767px) {
    margin-bottom: 7px;
    font-size: 15px;
    line-height: 19px;
  }
}
.gift-calc-card__gifts {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 21px;
  @media(max-width: 767px) {
    margin-bottom: 0;
    margin-left: auto;
  }
  img {
    flex-shrink: 0;
    &:not(:last-of-type) {
      margin-right: 11px;
    }
    @media(max-width: 767px) {
      &:not(:last-of-type) {
        margin-right: 0;
      }
      &:not(:first-of-type) {
        margin-left: 12px;
      }
    }
    @media(max-width: 1200px) {
      &:nth-of-type(6) {
        display: none;
      }
    }
    @media(max-width: 1050px) {
      &:nth-of-type(5),
      &:nth-of-type(4) {
        display: none;
      }
    }
    @media(max-width: 425px) {
      &:nth-of-type(3) {
        display: none;
      }
    }
    @media(max-width: 369px) {
      &:nth-of-type(2) {
        display: none;
      }
    }
  }
}
.gift-calc-card__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 205px;
  min-height: 34px;
  padding: 5px 15px;
  font-weight: 700;
  font-size: 17px;
  leading-trim: Cap height;
  line-height: 20px;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #FFFFFF;
  border-radius: 100px;
  background-color: #ED1651;
  @media(max-width: 767px) {
    padding: 3px 10px 5px 10px;
    font-size: 15px;
    line-height: 18px;
    min-width: 184px;
    min-height: 30px;
  }
}
.gift-calc-card__mobile {
  margin-right: 8px;
}
</style>
